import { App } from './app';

export class Emailtemplate {
    public id: number;
    public title: string;
    public body: string;
    public apps: App[] = [];
}

